// extracted by mini-css-extract-plugin
export default {"content":"OperationDetailInfo_content__unDfH","icon":"OperationDetailInfo_icon__8ElUg","content_error":"OperationDetailInfo_content_error__N3UHo"};